import { getAction } from '@/utils/request'

const VISIT_ID_KEY = 'hzarts_visit_id'
const BOT_UA_RE = /bot|spider|crawl|slurp|facebookexternalhit|pingdom|prerender|puppeteer|headless|phantomjs|selenium|webdriver/i

function createVisitId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '')
  }
  return `v${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`
}

function getVisitId() {
  try {
    let id = localStorage.getItem(VISIT_ID_KEY)
    if (!id) {
      id = createVisitId()
      localStorage.setItem(VISIT_ID_KEY, id)
    }
    return id
  } catch (e) {
    return createVisitId()
  }
}

function shouldSkipTracking() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return true
  }
  if (window.__PRERENDER_INJECTED) {
    return true
  }
  if (navigator.webdriver) {
    return true
  }
  const ua = navigator.userAgent || ''
  if (BOT_UA_RE.test(ua)) {
    return true
  }
  return false
}

/**
 * Fire-and-forget pageview. Never throws to callers.
 */
export function recordPageView(path) {
  try {
    if (shouldSkipTracking()) {
      return
    }
    const visitId = getVisitId()
    const safePath = path || (window.location && window.location.pathname) || '/'
    getAction('/biz/siteVisit/record', {
      path: safePath,
      visitId,
    }).catch(() => {})
  } catch (e) {
    // ignore
  }
}
